import PrivateApp  from './private-app';
import PublicApp from "./public-app";

import "./app.scss";


const App = {
    Public : PublicApp,
    Private : PrivateApp
};


export default App;